import TextArea from "antd/es/input/TextArea";
import Commonformlabel from "./CommonFormLabel";
import Commonformerror from "./CommonFormError";
import { ConfigProvider } from "antd";

function Commontextarea({
  labelname,
  name,
  value,
  onChange,
  error,
  touched,
  required = false,
  maxLength,
}: {
  labelname: string;
  name: string;
  value: any;
  onChange: (value: any) => void;
  error?: any;
  touched?: any;
  required?: boolean;
  maxLength: number;
}) {
  return (
    <>
      <Commonformlabel labelname={labelname} required={required} />
      <ConfigProvider
        theme={{
          token: {},
        }}
      >
        <TextArea
          rows={4}
          placeholder={labelname}
          maxLength={maxLength}
          name={name}
          value={value}
          onChange={onChange}
          style={{ color: "#000000" }}
        />
      </ConfigProvider>

      <Commonformerror
        required={required}
        touched={touched}
        name={name}
        error={error}
      />
    </>
  );
}

export default Commontextarea;
